import React, { useEffect, useState, useContext } from "react";
import CurrencyFormat from "react-currency-format";
import { Dropdown, Image, Card, Accordion, Offcanvas } from "react-bootstrap";
import "rc-slider/assets/index.css";
import { useNavigate, useParams, useLocation, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import SocketContext from "../../context/SocketContext";
import { Scrollbars } from "react-custom-scrollbars-2";
import { useTranslation } from "react-i18next";
import { motion, AnimatePresence } from "framer-motion";

// import components
import OpenPosition from "./OpenPosition";
import PendingPosition from "./pendingPosition"
import TradeviewChart from "./TradeviewChart";
import ClosedOrders from "./ClosedOrder";
import Orderplace from "./orderplace";

//import apis
import {
  getPairList,
  setPairList,
  setMarketPrice,
  setTradePair,
  getAssetByCurrency,
  setUserFirstCurrency,
  setUserSecondCurrency,
  getMarketPrice,
  getAllOpenPosition,
  getAllPendingPosition,
  updateTradeAsset,
  closeAllOrder,
} from "../../api/tradeAction";

// lib
import isEmpty from "../../lib/isEmpty";
import { unrealizedPnL } from "../../lib/bybit";
import { toFixedDown, truncateDecimals } from "../../lib/roundOf";
import { userWalletList } from "../../api/walletAction";
import { toastAlert } from "../../lib/toastAlert";
import { dateTimeFormat } from "../../lib/dateTimeHelper";
import { IncCntObjId } from "../../lib/generalFun";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import OrderBook from "./OrderBook";
import TopStories from "./TopStories";
import EconomicCalender from "./EconomicCalender";

const assetType = ["Crypto", "Currencies", "Stocks", "Indices", "Commodities"];

const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
  <button
    {...props}
    className={"absolute z-20 left-1 top-1/2 -translate-y-1/2 flex justify-center items-center w-6 h-6 focus:outline-none transition-all " + (props.className?.includes("slick-disabled") ? "opacity-50 cursor-not-allowed" : "cursor-pointer")}
    style={{ display: "flex" }}
  >
    <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M4.10492 0.0333126C4.26837 0.101026 4.375 0.260556 4.375 0.43751V7.4375C4.375 7.61448 4.26843 7.77396 4.10492 7.84169C3.94147 7.90941 3.75328 7.87202 3.62816 7.7469L0.128142 4.24696C-0.0427101 4.0761 -0.0427162 3.79907 0.128136 3.62822L3.6281 0.128157C3.75323 0.00303181 3.94141 -0.0344007 4.10492 0.0333126Z" fill="#395645" />
    </svg>
  </button>
);

const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
  <button
    {...props}
    className={"absolute z-20 right-1 top-1/2 -translate-y-1/2 flex justify-center items-center w-6 h-6 focus:outline-none transition-all " + (props.className?.includes("slick-disabled") ? "opacity-50 cursor-not-allowed" : "cursor-pointer")}
    style={{ display: "flex" }}
  >
    <svg className="rotate-180" width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M4.10492 0.0333126C4.26837 0.101026 4.375 0.260556 4.375 0.43751V7.4375C4.375 7.61448 4.26843 7.77396 4.10492 7.84169C3.94147 7.90941 3.75328 7.87202 3.62816 7.7469L0.128142 4.24696C-0.0427101 4.0761 -0.0427162 3.79907 0.128136 3.62822L3.6281 0.128157C3.75323 0.00303181 3.94141 -0.0344007 4.10492 0.0333126Z" fill="#395645" />
    </svg>
  </button>
);
const Trade = () => {
  const history = useNavigate();
  const { tikerRoot } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const socketContext = useContext(SocketContext);
  const { t, i18n } = useTranslation();

  //state
  const [activeTradeMethod, setActiveTradeMethod] = useState("buy");
  const [pairLists, setPairLists] = useState([]);
  const [totalpair, setTotalPair] = useState([]);
  const [pairdatas, setPairdatas] = useState([]);
  const [CloseAllLoder, setCloseAllLoder] = useState(false);
  const [totalPNL, setTotalPNL] = useState(0);
  const [available, setAvailable] = useState({});
  const [tradedata, setTradeData] = useState([]);
  const [pendingdata, setPendingData] = useState([]);
  const [currencyData, setCurrency] = useState([]);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [showMobileTrade, setShowMobileTrade] = useState(false);

  //redux
  const pairData = useSelector((state) => state.tradePair);
  const pairListData = useSelector((state) => state.pairList);
  const walletData = useSelector((state) => state.wallet);
  const currency = useSelector((state) => state.currency);
  const priceConversion = useSelector((state) => state.priceConversion);
  const marketPrice = useSelector((state) => state.marketPrice);

  //function
  const handleStakingMethodClick = (button) => {
    setActiveTradeMethod(button);
  };

  const fetchAssetByCurrency = async (spotPairId, type) => {
    try {
      const { status, result } = await getAssetByCurrency(spotPairId);
      if (status == "success") {
        if (type == "firstCurrency") {
          setUserFirstCurrency(result, dispatch);
        } else if (type == "secondCurrency") {
          setUserSecondCurrency(result, dispatch);
        }
      } else {
      }
    } catch (err) {
      console.log(err, "errro");
    }
  };

  const fetchPairList = async () => {
    try {
      const { status, result } = await getPairList();
      if (status == "success") {
        setPairdatas(result);
        setPairList(result, dispatch);
        if (result && result.length > 0) {
          if (isEmpty(tikerRoot)) {
            let pair = `${result[0].firstCurrencySymbol}_${result[0].secondCurrencySymbol}`;
            console.log(result[0], result[0].tikerRoot, "result[0]result[0]")
            history("/trade/" + result[0].tikerRoot);
            await fetchAssetByCurrency(
              result[0].firstCurrencyId,
              "firstCurrency"
            );
            await fetchAssetByCurrency(
              result[0].secondCurrencyId,
              "secondCurrency"
            );
            await setMarketPrice(result[0], dispatch);
            await setTradePair(result[0], dispatch);
            // getMarketPrice(result[0]._id, dispatch);
          } else {
            let currency = tikerRoot.split("_");
            let pairDetail = result.find((el) => el.tikerRoot == tikerRoot);
            // console.log("pairDetail", pairDetail);
            if (isEmpty(pairDetail && pairDetail)) {
              history("/404");
            }
            await fetchAssetByCurrency(
              pairDetail?.firstCurrencyId,
              "firstCurrency"
            );
            await fetchAssetByCurrency(
              pairDetail?.secondCurrencyId,
              "secondCurrency"
            );
            // // getMarketPrice(pairDetail._id, dispatch);
            await setMarketPrice(pairDetail, dispatch);
            await setTradePair(pairDetail, dispatch);
          }
        }
      } else {
      }
    } catch (err) {
      console.log("errrrrrrrr", err);
    }
  };

  const handlePairChange = async (datas) => {
    let pair = `${datas.firstCurrencySymbol}_${datas.secondCurrencySymbol}`;
    history("/trade/" + datas.tikerRoot);
    await fetchAssetByCurrency(datas.firstCurrencyId, "firstCurrency");
    await fetchAssetByCurrency(datas.secondCurrencyId, "secondCurrency");
    await setMarketPrice(datas, dispatch);
    await setTradePair(datas, dispatch);
    // socketContext.socket.off("marketPrice");
  };

  const handleAsset = async () => {
    try {
      let totalAmount = 0;
      let lockedBal = 0;
      let tempArr = [...walletData];
      let currencyArr = [];
      currency?.length >= 0 &&
        currency.map((item, index) => {
          let PriceCnv = priceConversion.find(
            (el) =>
              el.baseSymbol == item.currencySymbol && el.convertSymbol == "USD"
          );

          currencyArr.push({
            image: item.image,
            coin: item.currencySymbol,
            decimals: item.decimals,
            gateWay: item.gateWay,
            USDValue: !isEmpty(PriceCnv?.convertPrice)
              ? parseFloat(PriceCnv.convertPrice)
              : 1,
          });

          let pairIndex =
            tempArr &&
            tempArr.findIndex((el) => {
              return el._id == item._id;
            });
          if (pairIndex >= 0 && !isEmpty(pairIndex)) {
            tempArr[pairIndex] = {
              ...tempArr[pairIndex],
              ...{
                lockedBal: !isEmpty(PriceCnv?.convertPrice)
                  ? parseFloat(tempArr[pairIndex].lockedBal) *
                  parseFloat(PriceCnv.convertPrice)
                  : parseFloat(tempArr[pairIndex].lockedBal),
                USDValue: !isEmpty(PriceCnv?.convertPrice)
                  ? parseFloat(
                    tempArr[pairIndex].stakeBal - tempArr[pairIndex].lockedBal
                  ) * parseFloat(PriceCnv.convertPrice)
                  : parseFloat(
                    tempArr[pairIndex].stakeBal - tempArr[pairIndex].lockedBal
                  ),
              },
            };
            totalAmount += tempArr[pairIndex].USDValue;
            lockedBal += tempArr[pairIndex].lockedBal;
          }
        });
      setCurrency(currencyArr);

      let result = {
        totalBal: truncateDecimals(totalAmount, 2),
        lockedBal: truncateDecimals(lockedBal, 2),
      };
      setAvailable(result);
    } catch (err) {
      console.log("err:------ ", err);
    }
  };

  const fetchTradeHistory = async () => {
    const { status, result } = await getAllOpenPosition({});
    if (status == "success") {
      // console.log(result)
      setTradeData(result);
      // let totalPnl = 0
      // result?.result && result?.result?.length > 0 && result.result.map((item, key) => {
      //   let price = item.side == "sell" ? item.askPrice : item.bidPrice;
      //   let pnl = unrealizedPnL({
      //     entryPrice: item.entryPrice,
      //     quantity: item.quantity,
      //     lastPrice: price,
      //     buyorsell: item.side,
      //   })
      //   totalPnl += pnl
      // })
      // setTotalPNL(truncateDecimals(totalPnl, 2))
    }
  };

  const getallPendingData = async () => {
    const { status, result } = await getAllPendingPosition({});
    if (status == "success") {
      setPendingData(result);
    }
  }

  const handleCloseAll = async () => {
    try {
      setCloseAllLoder(true);
      const { status, loading, message, result, errors } =
        await closeAllOrder();
      if (status) {
        setCloseAllLoder(false);
        toastAlert("success", t(message), "login");
      } else {
        setCloseAllLoder(false);
        toastAlert("error", t(message), "login");
      }
    } catch (err) {
      setCloseAllLoder(false);
      console.log(err, "errorr");
    }
  };

  useEffect(() => {
    let pathname = location.pathname;

    if (!isEmpty(pairData)) {
      if (pathname == "/trade/" + pairData.tikerRoot) {
        // console.log("1111111");
        // socket
        let allPairPriceUpdate = [...pairdatas];
        socketContext.socket.on("marketPrice", (result) => {
          if (result.pairId == pairData.pairId) {
            setMarketPrice(result.data, dispatch);
            let tempPairList = pairLists;
            let pairIndex = tempPairList.findIndex(
              (el) => el._id == result.pairId
            );
            if (pairIndex >= 0) {
              tempPairList[pairIndex] = {
                ...tempPairList[pairIndex],
                ...{ markPrice: 0, change: result.data.change },
              };
              setPairLists(tempPairList);
            }
          }
          if (result) {
            let pairIndex = allPairPriceUpdate.findIndex((el) => {
              return el._id.toString() == result.pairId.toString();
            });
            if (pairIndex >= 0) {
              allPairPriceUpdate[pairIndex] = {
                ...allPairPriceUpdate[pairIndex],
                ...{
                  bidPrice: result?.data?.bidPrice,
                  askPrice: result?.data?.askPrice,
                  markPrice: result?.data?.markPrice,
                  change: result?.data?.change,
                },
              };
              // setPairList(tempPairList ,dispatch)
              setTotalPair(allPairPriceUpdate);
            }
          }
        });
        return () => {
          socketContext.socket.off("marketPrice");
        };
      }
    }
  }, [pairData]);

  useEffect(() => {
    if (pairListData && pairListData.length > 0) {
      setPairLists(pairListData);
      setTotalPair(pairListData);
    }
  }, [pairListData]);



  useEffect(() => {
    fetchPairList();
    fetchTradeHistory();
    getallPendingData()
  }, []);


  useEffect(() => {
    handleAsset();
    socketContext.socket.on("updateWallet", (result) => {
      // console.log(result, '888888888')
      dispatch(userWalletList(result?.walletData));
    });
  }, [currency, walletData, priceConversion]);

  useEffect(() => {
    if (tradedata && tradedata.length > 0 && !isEmpty(totalpair)) {
      let totalPnl = 0;
      tradedata &&
        tradedata?.length > 0 &&
        tradedata.map((item, key) => {
          let filter =
            totalpair &&
            totalpair.find((el) => el._id.toString() == item.pairId.toString());
          // console.log(item, 'filterfilter')
          let price = item.side == "sell" ? filter?.askPrice : filter?.bidPrice;
          let pnl = unrealizedPnL({
            entryPrice: item.entryPrice,
            quantity: item.quantity,
            lastPrice: price,
            buyorsell: item.side,
          });
          // let pnl = pAndL + filter?.spread
          let totalSpread =
            parseFloat(item?.userId?.userSpread) +
            parseFloat(filter?.spread) +
            parseFloat(item?.tradeSpread);
          let margin = (price * item.quantity) / 100
          let pnlper = totalSpread * margin / 100
          totalPnl += pnl + pnlper;
        });
      setTotalPNL(truncateDecimals(totalPnl, 2));
    }
  }, [marketPrice, totalpair, tradedata]);

  let Equity = parseFloat(available.totalBal) + parseFloat(totalPNL);

  const tickerSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    cssEase: "ease-in-out",
    slidesToShow: 7,
    slidesToScroll: 1,
    arrows: true,
    variableWidth: true,
    swipeToSlide: true,
    prevArrow: <SlickArrowLeft />,
    nextArrow: <SlickArrowRight />,
    responsive: [
      { breakpoint: 1400, settings: { slidesToShow: 5 } },
      { breakpoint: 1200, settings: { slidesToShow: 4 } },
      { breakpoint: 992, settings: { slidesToShow: 3, arrows: false, autoplay: true, autoplaySpeed: 0, speed: 3000, cssEase: "linear", pauseOnHover: false } },
      { breakpoint: 576, settings: { slidesToShow: 2, arrows: false, autoplay: true, autoplaySpeed: 0, speed: 3000, cssEase: "linear", pauseOnHover: false } },
    ],
  };

  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    margin: 30,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const [Info, setInfo] = useState();

  // console.log(Info, "-InfoInfo");

  let FindImage =
    pairLists.length > 0 &&
    pairLists.find((item) => item?._id === Info?.pairId?._id);

  console.log(pendingdata, "pendingdatapendingdata")
 const tradePanelContent = (
    <div className="w-full h-full bg-white rounded-sm lg:outline lg:outline-1 lg:outline-offset-[-1px] lg:outline-[#eff1f0] lg:p-4">
      <div className="staking_calc trade_buy">
        <div className="staking_method_btngrp !flex-nowrap">
          <button
            className={
              activeTradeMethod === "buy"
                ? "trade_buy trade_btn active"
                : "trade_buy trade_btn"
            }
            onClick={() => handleStakingMethodClick("buy")}
          >
            {t("BUY")}
          </button>
          <button
            className={
              activeTradeMethod === "sell"
                ? "trade_sell trade_btn active"
                : "trade_sell trade_btn"
            }
            onClick={() => handleStakingMethodClick("sell")}
          >
            {t("SELL")}
          </button>
        </div>
        <div className="">
          <div className="form-group">
            <label className="form-label">{t("ASSET")}</label>

            <Dropdown className="image_dropdown_wrapper" drop="down">
              <Dropdown.Toggle
                id="dropdown-basic"
                className="image_dropdown"
              >
                <Image src={pairData.image} width={38} height={38} />
                {pairData.firstCurrencySymbol}/
                {pairData.secondCurrencySymbol}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                {pairLists.map((option, i) => {
                  let symbole = `${option.firstCurrencySymbol}/${option.secondCurrencySymbol}`;
                  return (
                    <Dropdown.Item
                      key={i}
                      onClick={() => handlePairChange(option)}
                    >
                      <Image src={option.image} width={38} height={38} />{" "}
                      {symbole}
                    </Dropdown.Item>
                  );
                })}
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <Orderplace
            type={activeTradeMethod}
            refetch={fetchTradeHistory}
            pendingrefetch={getallPendingData}
            handleAsset={handleAsset}
            pairData={pairData}
            totalpair={totalpair}
          />
        </div>
      </div>
    </div>
  );
  return (
    <>
      {/* crypto trade */}
      <div className="p-4 pb-24 lg:pb-4">

        <div className="w-full flex justify-start items-center gap-4">
          <div className="flex-1 w-full lg:w-auto p-2 relative rounded overflow-hidden border border-[#6B7280]/25">
            <Slider {...tickerSettings}>
              {totalpair && totalpair.length > 0 && totalpair.map((item, index) => (
                <div key={index} onClick={() => handlePairChange(item)} className="cursor-pointer px-2 outline-none">
                  <div className="min-w-[100px] lg:min-w-[150px] pr-2 border-r border-[#6b7280]/25 flex flex-col lg:flex-row justify-center lg:justify-start items-start lg:items-center gap-1 lg:gap-2">
                    <div className="flex items-center gap-2">
                      <img className="w-5 h-5 rounded-full object-cover" src={item.image} alt={item.firstCurrencySymbol} />
                      <div className="justify-center text-[#395645] text-sm font-semibold font-['Roobert']">{item.firstCurrencySymbol}</div>
                    </div>
                    <div className="justify-center text-[#6b7280] text-sm font-normal font-['Roobert']">
                      $ {truncateDecimals(Number(item.markPrice || item.bidPrice || 0), item.secondFloatDigit || 4)}
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
            <div className="hidden lg:block w-16 h-full right-0 top-0 absolute bg-gradient-to-l from-white to-transparent pointer-events-none" />
            <div className="hidden lg:block w-16 h-full left-0 top-0 absolute bg-gradient-to-r from-white to-transparent pointer-events-none" />
          </div>
          <Link to="/protrade" className="primary_btn hidden lg:flex">
            <div className="">{t("PRO_TRADE")}</div>
          </Link>
        </div>


        <div className="md:border border-[#6B7280]/25 md:p-4 rounded mt-4">
          <div className="w-full self-stretch p-3 lg:p-2 relative bg-[#F4F3F3] shadow-sm rounded-sm flex flex-wrap lg:flex-nowrap justify-between lg:justify-start items-center gap-y-4 lg:gap-6 overflow-hidden">
            <img className="absolute right-0 top-0 h-full object-cover  pointer-events-none hidden lg:block" style={{ filter: "blur(0px)", mixBlendMode: "color-burn" }} src="/images/inner/bg.png" alt="background" />
            <div className="w-[48%] lg:w-auto lg:flex-1 lg:pr-6 lg:border-r border-[#395645]/25 flex flex-col justify-center items-start gap-0.5 relative z-10">
              <div className="justify-center text-[#6b7280] text-sm font-normal font-['Roobert']">PNL:</div>
              <div className={`justify-center text-sm font-semibold font-['Roobert'] ${totalPNL >= 0 ? "text-[#395645]" : "text-red-500"}`}>
                $ <CurrencyFormat
                  displayType={'text'}
                  thousandSeparator={true}
                  value={truncateDecimals(totalPNL, 2)}
                />
              </div>
            </div>
            <div className="w-[48%] lg:w-auto lg:flex-1 lg:pr-6 lg:border-r border-[#395645]/25 flex flex-col justify-center items-start gap-0.5 relative z-10">
              <div className="justify-center text-[#6b7280] text-sm font-normal font-['Roobert']">Cash Bal:</div>
              <div className="justify-center text-[#395645] text-sm font-semibold font-['Roobert']">
                $ <CurrencyFormat
                  displayType={'text'}
                  thousandSeparator={true}
                  value={available?.totalBal}
                />
              </div>
            </div>
            <div className="w-[48%] lg:w-auto lg:flex-1 lg:pr-6 lg:border-r border-[#395645]/25 flex flex-col justify-center items-start gap-0.5 relative z-10">
              <div className="justify-center text-[#6b7280] text-sm font-normal font-['Roobert']">Equity:</div>
              <div className={`justify-center text-sm font-semibold font-['Roobert'] ${Equity >= 0 ? "text-[#395645]" : "text-red-500"}`}>
                $ <CurrencyFormat
                  displayType={'text'}
                  thousandSeparator={true}
                  value={truncateDecimals(Equity, 2)}
                />
              </div>
            </div>
            <div className="w-[48%] lg:w-auto lg:flex-1 lg:pr-6 lg:border-r border-[#395645]/25 flex flex-col justify-center items-start gap-0.5 relative z-10">
              <div className="justify-center text-[#6b7280] text-sm font-normal font-['Roobert']">Used Margin:</div>
              <div className="justify-center text-[#395645] text-sm font-semibold font-['Roobert']">
                $ <CurrencyFormat
                  displayType={'text'}
                  thousandSeparator={true}
                  value={available?.lockedBal}
                />
              </div>
            </div>
            <div className="w-[48%] lg:w-auto lg:flex-1 lg:pr-6 flex flex-col justify-center items-start gap-0.5 relative z-10">
              <div className="justify-center text-[#6b7280] text-sm font-normal font-['Roobert']">Available Margin:</div>
              <div className="justify-center text-[#395645] text-sm font-semibold font-['Roobert']">
                $ <CurrencyFormat
                  displayType={'text'}
                  thousandSeparator={true}
                  value={available?.totalBal}
                />
              </div>
            </div>
          </div>

          {/* dropdown  */}
          <div className="hidden lg:flex w-full self-stretch justify-start items-center gap-4 mt-4 relative z-20">
            {assetType.map((asset, index) => {
              let assetTypeFilter = asset === "Currencies" ? "currency" : asset.toLowerCase();
              let displayAsset = asset;
              if (asset === "Crypto") displayAsset = t("CRYPTO");
              else if (asset === "Currencies") displayAsset = t("CURRENCIES");
              else if (asset === "Commodities") displayAsset = t("COMMODITIES");
              else if (asset === "Stocks") displayAsset = t("STOCKS");
              else if (asset === "Indices") displayAsset = t("INDICES");

              const isOpen = openDropdown === index;

              return (
                <div key={index} className="flex-1 relative">
                  <div
                    onClick={() => setOpenDropdown(isOpen ? null : index)}
                    className="w-full p-2 rounded-sm outline outline-1 outline-offset-[-1px] outline-[#6B7280]/25 inline-flex flex-col justify-start items-center gap-6 cursor-pointer bg-white transition-colors hover:bg-gray-50"
                  >
                    <div className="self-stretch inline-flex justify-between items-center">
                      <div className="justify-center text-gray-500 text-base font-normal font-['Roobert']">{displayAsset}</div>
                      <motion.div animate={{ rotate: isOpen ? 180 : 0 }}>
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fillRule="evenodd" clipRule="evenodd" d="M3.09581 5.08258C3.16353 4.91913 3.32306 4.8125 3.50001 4.8125L10.5 4.8125C10.677 4.8125 10.8365 4.91907 10.9042 5.08258C10.9719 5.24603 10.9345 5.43422 10.8094 5.55934L7.30946 9.05936C7.1386 9.23021 6.86157 9.23022 6.69072 9.05936L3.19066 5.5594C3.06553 5.43427 3.0281 5.24609 3.09581 5.08258Z" fill="#6B7280" />
                        </svg>
                      </motion.div>
                    </div>
                  </div>
                  <AnimatePresence>
                    {isOpen && (
                      <motion.div
                        initial={{ opacity: 0, y: -10, height: 0 }}
                        animate={{ opacity: 1, y: 0, height: "auto" }}
                        exit={{ opacity: 0, y: -10, height: 0 }}
                        className="absolute top-full left-0 w-full mt-1 bg-white border border-[#eff1f0] rounded-sm shadow-lg z-30 overflow-hidden"
                      >
                        <Scrollbars style={{ width: "100%", height: "200px" }} autoHide>
                          <div className="flex flex-col">
                            {pairLists
                              .filter((option) => option.type === assetTypeFilter)
                              .map((option, i) => {
                                let symbole = option.firstCurrencySymbol;
                                if (option.type === "currency") symbole = `${option.firstCurrencySymbol}/USD`;
                                return (
                                  <div
                                    key={i}
                                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer flex items-center gap-2 text-sm text-gray-700 font-['Roobert'] transition-colors"
                                    onClick={() => {
                                      handlePairChange(option);
                                      setOpenDropdown(null);
                                    }}
                                  >
                                    <img src={option.image} alt={symbole} width={20} height={20} className="rounded-full" />
                                    {symbole}
                                  </div>
                                );
                              })}
                            {pairLists.filter((option) => option.type === assetTypeFilter).length === 0 && (
                              <div className="px-4 py-3 text-sm text-gray-500 text-center font-['Roobert']">
                                {t("NO_DATA") || "No pairs available"}
                              </div>
                            )}
                          </div>
                        </Scrollbars>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              );
            })}
          </div>

          {/* Mobile Single Dropdown and Pro Trade Button */}
          <div className="lg:hidden w-full self-stretch flex justify-between items-center gap-4 mt-4 relative z-30">
            <div className="flex-1 max-w-[250px] relative">
              <div
                onClick={() => setOpenDropdown(openDropdown === 'mobile_all' ? null : 'mobile_all')}
                className="w-full p-3 rounded-sm outline outline-1 outline-offset-[-1px] outline-[#6B7280]/25 flex justify-between items-center cursor-pointer bg-white transition-colors hover:bg-gray-50"
              >
                <div className="flex items-center gap-3">
                  {pairData?.image ? (
                    <Image src={pairData.image} width={24} height={24} className="rounded-full" />
                  ) : (
                    <div className="w-6 h-6 bg-gray-200 rounded-full"></div>
                  )}
                  <div className="text-[#395645] text-base font-semibold font-['Roobert']">
                    {pairData?.firstCurrencySymbol}/{pairData?.secondCurrencySymbol}
                  </div>
                </div>
                <motion.div animate={{ rotate: openDropdown === 'mobile_all' ? 180 : 0 }}>
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M3.09581 5.08258C3.16353 4.91913 3.32306 4.8125 3.50001 4.8125L10.5 4.8125C10.677 4.8125 10.8365 4.91907 10.9042 5.08258C10.9719 5.24603 10.9345 5.43422 10.8094 5.55934L7.30946 9.05936C7.1386 9.23021 6.86157 9.23022 6.69072 9.05936L3.19066 5.5594C3.06553 5.43427 3.0281 5.24609 3.09581 5.08258Z" fill="#6B7280" />
                  </svg>
                </motion.div>
              </div>
              <AnimatePresence>
                {openDropdown === 'mobile_all' && (
                  <motion.div
                    initial={{ opacity: 0, y: -10, height: 0 }}
                    animate={{ opacity: 1, y: 0, height: "auto" }}
                    exit={{ opacity: 0, y: -10, height: 0 }}
                    className="absolute top-full left-0 w-full mt-1 bg-white border border-[#eff1f0] rounded-sm shadow-lg z-40 overflow-hidden"
                  >
                    <Scrollbars style={{ width: "100%", height: "250px" }} autoHide>
                      <div className="flex flex-col">
                        {assetType.map((asset) => {
                          let assetTypeFilter = asset === "Currencies" ? "currency" : asset.toLowerCase();
                          let filteredPairs = pairLists.filter((option) => option.type === assetTypeFilter);
                          
                          if (filteredPairs.length === 0) return null;

                          let displayAsset = asset;
                          if (asset === "Crypto") displayAsset = t("CRYPTO");
                          else if (asset === "Currencies") displayAsset = t("CURRENCIES");
                          else if (asset === "Commodities") displayAsset = t("COMMODITIES");
                          else if (asset === "Stocks") displayAsset = t("STOCKS");
                          else if (asset === "Indices") displayAsset = t("INDICES");

                          return (
                            <React.Fragment key={asset}>
                              <div className="px-4 py-1.5 bg-gray-50 text-xs font-bold text-gray-500 uppercase sticky top-0 z-10 border-b border-gray-100">
                                {displayAsset}
                              </div>
                              {filteredPairs.map((option, i) => {
                                let symbole = `${option.firstCurrencySymbol}/${option.secondCurrencySymbol}`;
                                return (
                                  <div
                                    key={i}
                                    className="px-4 py-3 hover:bg-gray-100 cursor-pointer flex justify-between items-center gap-2 text-sm text-gray-700 font-['Roobert'] transition-colors border-b border-gray-50 last:border-0"
                                    onClick={() => {
                                      handlePairChange(option);
                                      setOpenDropdown(null);
                                    }}
                                  >
                                    <div className="flex items-center gap-3">
                                      <Image src={option.image} alt={symbole} width={24} height={24} className="rounded-full" />
                                      <span className="font-semibold text-[#395645]">{symbole}</span>
                                    </div>
                                    {/* <div className="text-gray-400 text-xs uppercase">{option.type}</div> */}
                                  </div>
                                );
                              })}
                            </React.Fragment>
                          );
                        })}
                        {pairLists.length === 0 && (
                          <div className="px-4 py-3 text-sm text-gray-500 text-center font-['Roobert']">
                            {t("NO_DATA") || "No pairs available"}
                          </div>
                        )}
                      </div>
                    </Scrollbars>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
            <Link to="/protrade" className="primary_btn !py-2.5 !px-4 text-sm whitespace-nowrap shrink-0">
              {t("PRO_TRADE")}
            </Link>
          </div>

          {/* per row buy and sell, chart */}
          <div className="flex flex-col lg:flex-row gap-4 mt-4">
            {/* Desktop Buy / Sell */}
            <div className="hidden lg:block w-full 2xl:w-[25%] lg:w-[30%]">
              {tradePanelContent}
            </div>

            {/* Chart */}
            <div className="w-full 2xl:w-[75%] lg:w-[70%]">
              <div className="w-full h-[500px] lg:h-full min-h-[500px] bg-white rounded-sm ">
                <div className="tradingview-widget-container h-full">
                  <TradeviewChart />
                </div>
              </div>
            </div>
          </div>

           {/* table */}
          <div className="w-full mt-4 ">
            <div className="staking_top_flex">
              <ul
                className="nav nav-pills custom_nav_tabs w-100"
                id="pills-tab"
                role="tablist"
              >
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    id="pills-OpenPosition-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-OpenPosition"
                    type="button"
                    role="tab"
                    aria-controls="pills-OpenPosition"
                    aria-selected="true"
                  >
                    {t("OPEN_POSITIONS")}
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="pills-trade-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-trade"
                    type="button"
                    role="tab"
                    aria-controls="pills-trade"
                    aria-selected="false"
                  >
                    {t("CLOSED_POSITIONS")}
                  </button>
                </li>
                {pendingdata.length > 0 && (
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="pills-PendPosition-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-PendPosition"
                      type="button"
                      role="tab"
                      aria-controls="pills-PendPosition"
                      aria-selected="true"
                    >
                      {t("PENDING_POSITIONS")}
                    </button>
                  </li>
                )}
                {tradedata.length > 0 && (
                  <li className="ms-lg-auto">
                    <button
                      className="nav-link active primary_btn close_btn"
                      disabled={CloseAllLoder}
                      onClick={handleCloseAll}
                    >
                      {t("CLOSE_ALL_TRADES")}
                    </button>
                  </li>
                )}
              </ul>
            </div>
            <div className="tab-content mt-4" id="pills-tabContent">
              {pendingdata.length > 0 && (
                <div
                  className="tab-pane fade"
                  id="pills-PendPosition"
                  role="tabpanel"
                  aria-labelledby="pills-PendPosition-tab"
                >
                  <PendingPosition
                    totalpair={totalpair}
                    refetch={getallPendingData}
                    handleAsset={handleAsset}
                  />
                </div>
              )}
              <div
                className="tab-pane fade show active"
                id="pills-OpenPosition"
                role="tabpanel"
                aria-labelledby="pills-OpenPosition-tab"
              >
                <OpenPosition
                  totalpair={totalpair}
                  refetch={fetchTradeHistory}
                  handleAsset={handleAsset}
                />
              </div>
              <div
                className="tab-pane fade"
                id="pills-trade"
                role="tabpanel"
                aria-labelledby="pills-trade-tab"
              >
                <ClosedOrders setInfo={setInfo} totalpair={totalpair} />
              </div>
            </div>
          </div>

          {/* per row order book, economic calendar */}
          <div className="flex flex-col lg:flex-row gap-4 mt-4">
            <div className="w-full lg:w-1/3 flex flex-col">
              <OrderBook />
            </div>
            <div className="w-full lg:w-2/3 flex flex-col">
              <div className="w-full  lg:h-full bg-white ">
                <EconomicCalender />
              </div>
            </div>
          </div>

          {/* top stories full col */}
          <div className="flex flex-col lg:flex-row gap-4 mt-4">
            <div className="w-full flex flex-col">
              <div className="w-full lg:min-h-[450px] h-full bg-white">
                <TopStories />
              </div>
            </div>
          </div>

         
        </div>
      </div>
      {/* Close Trade Info */}
      <div
        className="offcanvas offcanvas-end close_trade_info_offcanvas"
        tabindex="-1"
        id="offcanvasRight"
        aria-labelledby="offcanvasRightLabel"
      >
        <div className="offcanvas-header">
          <h5
            className="offcanvas-title d-flex gap-2 align-items-center"
            id="offcanvasRightLabel"
          >
            <img src={FindImage?.image} alt="img" width={30} height={30} />
            {Info?.pairName}
          </h5>
          <button
            type="button"
            className="border-0 bg-transparent p-0"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <svg width="25" height="25" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 0.9375C13.4528 0.9375 17.0625 4.54721 17.0625 9C17.0625 13.4528 13.4528 17.0625 9 17.0625C4.54721 17.0625 0.9375 13.4528 0.9375 9C0.9375 4.54721 4.54721 0.9375 9 0.9375ZM7.22315 6.16846C6.92858 5.9282 6.49432 5.94517 6.21973 6.21973C5.94523 6.49432 5.92822 6.9286 6.16846 7.22315L6.21973 7.28027L7.93943 9L6.22046 10.7198C5.92768 11.0126 5.92758 11.4874 6.22046 11.7802C6.51335 12.0729 6.98818 12.073 7.28101 11.7802L9 10.0606L10.719 11.7802L10.7762 11.8316C11.0706 12.0718 11.5049 12.0547 11.7796 11.7802C12.0541 11.5058 12.0716 11.0714 11.8316 10.7768L11.7796 10.7198L10.0598 9L11.7802 7.28027L11.8316 7.22315C12.0718 6.92859 12.0547 6.49432 11.7802 6.21973C11.5057 5.94517 11.0714 5.9282 10.7768 6.16846L10.7198 6.21973L9 7.93943L7.28027 6.21973L7.22315 6.16846Z" fill="#395645" />
            </svg>
          </button>
        </div>
        <div className="offcanvas-body">
          <div className="close_trade_info">
            <div>
              <label>Order Id</label>
              <label>{IncCntObjId(Info?._id)}</label>
            </div>
            <div>
              <label>PNL</label>
              <label>{truncateDecimals(Info?.pnl, 2)}</label>
            </div>
            <div>
              <label>Open Date</label>
              <label>{dateTimeFormat(Info?.openAt)}</label>
            </div>
            <div>
              <label>Close Date</label>
              <label>{dateTimeFormat(Info?.closedAt)}</label>
            </div>
            <div>
              <label>Open Price</label>
              <label>{truncateDecimals(Info?.entryPrice, 2)}</label>
            </div>
            <div>
              <label>Close Price</label>
              <label>{truncateDecimals(Info?.exitPrice, 2)}</label>
            </div>
            <div>
              <label>Used Margin</label>
              <label>{truncateDecimals(Info?.orderCost, 2)} USD</label>
            </div>
            <div>
              <label>Trade Size</label>
              <label>{truncateDecimals(Info?.quantity, 6)}</label>
            </div>
            <div>
              <label>Lots</label>
              <label>{Info?.leverage}</label>
            </div>
            <div>
              <label>Direction</label>
              <label
                className={
                  Info?.direction === "closed_long" ? "txt_green" : "txt_red"
                }
              >
                {Info?.direction === "closed_long" ? "BUY" : "SELL"}
              </label>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Sticky Buy/Sell Buttons */}
      <div className="lg:hidden fixed bottom-0 left-0 w-full bg-white border-t border-[#eff1f0] p-3 flex justify-between gap-3 z-[1000] shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)]">
        <button
          className="flex-1 bg-[#00b881] text-white md:py-3 py-2 rounded font-semibold font-['Roobert'] text-lg"
          onClick={() => {
            handleStakingMethodClick("buy");
            setShowMobileTrade(true);
          }}
        >
          {t("BUY")}
        </button>
        <button
          className="flex-1 bg-[#ff4d4f] text-white sm:py-3 py-2 rounded font-semibold font-['Roobert'] text-lg"
          onClick={() => {
            handleStakingMethodClick("sell");
            setShowMobileTrade(true);
          }}
        >
          {t("SELL")}
        </button>
      </div>

      {/* Mobile Trade Offcanvas */}
      <Offcanvas
        show={showMobileTrade}
        onHide={() => setShowMobileTrade(false)}
        placement="bottom"
        className="h-auto lg:hidden rounded-t-xl"
      >
        <Offcanvas.Header className="border-b border-[#eff1f0] py-3 justify-end">
          <button type="button" className="border-0 bg-transparent p-0" onClick={() => setShowMobileTrade(false)} aria-label="Close">
            <svg width="25" height="25" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 0.9375C13.4528 0.9375 17.0625 4.54721 17.0625 9C17.0625 13.4528 13.4528 17.0625 9 17.0625C4.54721 17.0625 0.9375 13.4528 0.9375 9C0.9375 4.54721 4.54721 0.9375 9 0.9375ZM7.22315 6.16846C6.92858 5.9282 6.49432 5.94517 6.21973 6.21973C5.94523 6.49432 5.92822 6.9286 6.16846 7.22315L6.21973 7.28027L7.93943 9L6.22046 10.7198C5.92768 11.0126 5.92758 11.4874 6.22046 11.7802C6.51335 12.0729 6.98818 12.073 7.28101 11.7802L9 10.0606L10.719 11.7802L10.7762 11.8316C11.0706 12.0718 11.5049 12.0547 11.7796 11.7802C12.0541 11.5058 12.0716 11.0714 11.8316 10.7768L11.7796 10.7198L10.0598 9L11.7802 7.28027L11.8316 7.22315C12.0718 6.92859 12.0547 6.49432 11.7802 6.21973C11.5057 5.94517 11.0714 5.9282 10.7768 6.16846L10.7198 6.21973L9 7.93943L7.28027 6.21973L7.22315 6.16846Z" fill="#395645" />
            </svg>
          </button>
          {/* <h5 className="offcanvas-title font-['Roobert'] text-[#395645] font-semibold" id="mobileTradeOffcanvasLabel">
            {t("PLACE_ORDER")}
          </h5> */}
        </Offcanvas.Header>
        <Offcanvas.Body className="p-4">
          {tradePanelContent}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default Trade;
